import React from 'react'
import CallMeBackInsteadBtn from 'src/Components/Common/CallMeBackInsteadBtn/CallMeBackInsteadBtn'
import WhatsappBtn from 'src/Components/Common/WhatsappBtn/WhatsappBtn'
import './AuthInfoReview.css'

const AuthInfoReview = (props) => {

  return (
    <>
      <div className='sticky-div'>
          <div className="auth-info-review-continue-button-wrapper">
          <span className='auth-info-review-text'>Please review all your information before continuing</span>
            <button 
              className='auth-info-review-continue-button'
              disabled={!props.enableNext}
              onClick={() => props.nextClick()}
            >
              Continue
            </button>
          </div>
        

          <div className='auth-info-review-callmeback-wrapper'>
            <span className='auth-info-review-text'>Prefer to speak to a consultant?</span>
            <WhatsappBtn/>
            <CallMeBackInsteadBtn/>
          </div>
      </div>

    </>
  );
}

export default AuthInfoReview;